import React, { useState, useEffect } from 'react';

export const XboxModal = ({ isOpen, onClose, onSubmit, initialData = null }) => {
	const [price, setPrice] = useState('');
	const [price_disc, setPrice_disc] = useState('');
	const [time, setTime] = useState('');
	const [type, setType] = useState('');

	useEffect(() => {
		if (initialData) {
			setPrice(initialData.price || 0);
			setPrice_disc(initialData.price_disc || 0);
			setTime(initialData.time || 0);
			setType(initialData.type || '');
		} else {
			setPrice('');
			setPrice_disc('');
			setTime('');
			setType('');
		}
	}, [initialData]);

	const handleSubmit = () => {
		if (!price || !time) {
			alert('Введите цену и время');
			return;
		}

		const promoData = {
			price,
			price_disc,
			time,
			type,
		};

		onSubmit(promoData);
	};

	if (!isOpen) return null;

	return (
		<div style={modalStyles}>
			<div style={modalContentStyles}>
				<input
					type="number"
					value={price}
					onChange={(e) => setPrice(e.target.value)}
					placeholder="цена"
					style={inputStyles}
				/>
				<input
					type="number"
					value={price_disc}
					onChange={(e) => setPrice_disc(e.target.value)}
					placeholder="цена со скидкой"
					style={inputStyles}
				/>
				<input
					type="number"
					value={time}
					placeholder="время действия"
					onChange={(e) => setTime(e.target.value)}
					style={inputStyles}
				/>

				<div style={checkboxContainerStyles}>
					<label style={checkboxLabelStyles}>
						<input
							type="radio"
							name="type"
							value="forNewAcc"
							checked={type === 'forNewAcc'}
							onChange={() => setType('forNewAcc')}
						/>
						Для нового аккаунта
					</label>
					<label style={checkboxLabelStyles}>
						<input
							type="radio"
							name="type"
							value="forPersonalAcc"
							checked={type === 'forPersonalAcc'}
							onChange={() => setType('forPersonalAcc')}
						/>
						Для личного аккаунта
					</label>
				</div>

				<div style={buttonContainerStyles}>
					<button onClick={handleSubmit} style={buttonStyles}>
						{initialData ? 'Сохранить' : 'Добавить'}
					</button>
					<button onClick={onClose} style={buttonStyles}>
						Закрыть
					</button>
				</div>
			</div>
		</div>
	);
};

// Стили
const modalStyles = {
	position: 'fixed',
	top: 0,
	left: 0,
	width: '100%',
	height: '100%',
	backgroundColor: 'rgba(0, 0, 0, 0.5)',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	zIndex: 1000,
};

const modalContentStyles = {
	backgroundColor: 'white',
	padding: '20px',
	borderRadius: '8px',
	width: '400px',
	maxHeight: '90%',
	overflowY: 'auto',
	textAlign: 'center',
};

const inputStyles = {
	width: '100%',
	padding: '10px',
	margin: '5px 0',
	borderRadius: '5px',
	border: '1px solid #ccc',
};

const checkboxContainerStyles = {
	display: 'flex',
	justifyContent: 'space-around',
	marginTop: '10px',
};

const checkboxLabelStyles = {
	color: 'black',
	display: 'flex',
	alignItems: 'center',
	gap: '5px',
};

const buttonContainerStyles = {
	display: 'flex',
	justifyContent: 'space-between',
	marginTop: '10px',
};

const buttonStyles = {
	padding: '10px',
	borderRadius: '5px',
	border: '1px solid #ccc',
	cursor: 'pointer',
};
